import { Search, SlidersHorizontal } from "lucide-react";
import { ProductCard } from "../../components/commerce/ProductCard";
import { products } from "../../data/products";

export function SearchPage() {
  return (
    <main className="page-canvas">
      <section className="container search-page">
        <div className="page-title">
          <h1>Tìm kiếm phụ tùng</h1>
          <p>Kết quả nhanh theo điện áp, công suất, dòng xe, mã SKU và tình trạng tồn kho.</p>
        </div>
        <form className="search-hero" onSubmit={(event) => event.preventDefault()}>
          <Search aria-hidden="true" />
          <input defaultValue="sạc xe điện 60V" aria-label="Từ khóa" />
          <button type="submit">Tìm kiếm</button>
        </form>
        <div className="quick-filter">
          {["60V", "48V", "800W", "VinFast", "Honda", "Có sẵn", "Bảo hành"].map((filter) => (
            <button key={filter} type="button">
              {filter}
            </button>
          ))}
          <button type="button">
            <SlidersHorizontal aria-hidden="true" /> Bộ lọc
          </button>
        </div>
        <div className="product-grid">
          {products.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      </section>
    </main>
  );
}
